import DraftNumberInput from "../../../inputs/DraftNumberInput";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const AutomationSuiteRobotsProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: any) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  const robotInput = (label: string, field: string) => (
    <DraftNumberInput
      label={label}
      product={product}
      field={field}
      baselineProfile={baselineProfile}
      editable={editable}
      onProductChange={onProductChange}
    />
  );

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <FlexSection>
        {robotInput("Small Robots", "concurrentSmallRobots")}
        {robotInput("Standard Robots", "concurrentStandardRobots")}
        {robotInput("Medium Robots", "concurrentMediumRobots")}
        {robotInput("Large Robots", "concurrentLargeRobots")}
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default AutomationSuiteRobotsProductWidget;
